<h4>HRSA Health Center Grantees and Look-Alikes, please note:</h4>
<ol type="1" class="padding-left-2">
  <li>
    The Health Center information represented on this website IS NOT representative of a Health Center's complete Scope
    of Project.
  </li>
  <li>
    If a Health Center identifies errors in the contact information of a Service Delivery Site, please follow the
    following instructions to fix the error:
  </li>
</ol>
<h5>
  Grantees: Registered users with access to the EHBs Grant Handbook can update the service delivery site information in
  the EHBs.
</h5>
<ol type="1" class="padding-left-2">
  <li>
    Log in to the EHBs (<a
      href="https://grants.hrsa.gov/EAuthNS/external/account/SignIn"
      target="_blank"
      class="usa-link usa-link--external"
      rel="noopener noreferrer"
      title="View Portfolio"
      >https://grants.hrsa.gov/EAuthNS/external/account/SignIn</a
    >) and click the “View Portfolio” link in the left menu.
  </li>
  <li>
    The list of grants you have added to your portfolio will be displayed. Click the “Open Grant Handbook” link for the
    Health Center program grant. (Grant number starting with H80)
  </li>
  <li>The Grant Handbook overview page will open. Click the “Sites” link in the left menu.</li>
  <li>
    The list of Sites in Scope will appear listed. Locate the site for which you want to update the information and
    click “Update”.
  </li>
  <li>
    The Update Site page will open. Make the necessary changes by selecting the “Update” button in the appropriate
    section.
  </li>
  <li>Once you have made all changes, click “Save and Continue” to save your changes.</li>
</ol>
<p>
  For more information about adding a grant to your portfolio, please visit
  <a
    title="Grants Management"
    href="https://help.hrsa.gov/pages/releaseview.action?pageId=22708234#GrantsAccessandRegistrationFAQs-HowcanIaddaGranttoMyPortfolio?"
    target="_blank"
    class="usa-link usa-link--external"
    rel="noopener noreferrer"
    >https://help.hrsa.gov/pages/releaseview.action?pageId=22708234#GrantsAccessandRegistrationFAQs-HowcanIaddaGranttoMyPortfolio?</a
  >.
</p>
<h5>Look-Alikes</h5>
<p>
  Log in to the EHBs (<a href="https://grants.hrsa.gov/EAuthNS/external/account/SignIn" target="_blank" title="Login" class="usa-link usa-link--external" rel="noopener noreferrer"
    >https://grants.hrsa.gov/EAuthNS/external/account/SignIn</a
  >).
</p>
<ol type="1" class="padding-left-2 padding-bottom-2">
  <li>Click on the FQHC-LALs tab.</li>
  <li>Click on the “View Portfolio” link in the FQHC-LAL Home drop-down menu.</li>

  <li>Click on the “Open Designation Handbook” link.</li>

  <li>Click on the “Update Sites Information” link.</li>

  <li>
    The list of sites in scope will appear listed. Locate the site for which you want to update the information and
    click “Update.”
  </li>

  <li>
    The Form-5B Edit page will open. Make the necessary changes by selecting the “Update” button in the appropriate
    section.
  </li>

  <li>Once you have made all changes, click “Save and Continue” to save your changes.</li>
</ol>
